import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Truck } from 'lucide-react';
import { useSEO } from '../utils/seo';
export function NotFound() {
  // Client-side routing always responds 200, so unmatched URLs would be
  // indexed as soft 404s. `noIndex` keeps them out of search results while
  // still letting crawlers follow the recovery links back into the site.
  useSEO({
    title: 'Page Not Found | 206Gravel',
    description: 'This page could not be found. Browse bulk gravel, rock, soil, and bark delivery across Seattle, King County, and Pierce County.',
    noIndex: true
  });
  return <main className="min-h-[calc(100vh-64px)] bg-[#f3f0ec] dark:bg-[#292827] flex items-center justify-center px-4 transition-colors duration-300" data-id="element-2969" data-mp="1jvyj5bznptu5">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-center max-w-md" data-id="element-2970" data-mp="1svbhb8ibyvzk">
        <div className="w-20 h-20 bg-brand-orange/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2971" data-mp="1nwdetga3uzzk">
          <Truck className="w-10 h-10 text-brand-orange" data-id="element-2972" data-mp="1iwhk67naskwo" />
        </div>

        <h1 className="font-heading text-6xl md:text-7xl font-extrabold text-stone-900 dark:text-white mb-3 tracking-tight" data-id="element-2973" data-mp="1euw2m8ztjig5">
          404
        </h1>
        <p className="text-lg text-stone-600 dark:text-stone-300 mb-8 font-sub" data-id="element-2974" data-mp="19xnjo66ujadu">
          This page must've taken a wrong turn. Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-2975" data-mp="22ki10u8d9tn3">
          <Link to="/" className="inline-flex items-center justify-center px-6 py-3 bg-brand-button hover:bg-brand-buttonHover text-white rounded-xl font-bold text-sm transition-colors" data-id="element-2976" data-mp="1xtrw1i3urssx">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2977" data-mp="2qacbx694l84p" />
            Back to Home
          </Link>
          <a href="tel:206-619-3742" className="inline-flex items-center justify-center px-6 py-3 border border-stone-300 dark:border-white/20 text-stone-900 dark:text-white rounded-xl font-bold text-sm hover:bg-stone-100 dark:hover:bg-white/5 transition-colors" data-id="element-2978" data-mp="2qc5latb4i6ge">
            Call (206) 619-3742
          </a>
        </div>
      </motion.div>
    </main>;
}